import { MessageSquare, DollarSign } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PHONE_DISPLAY, PHONE_SMS } from "@/lib/content";

const STEPS = [
  "Book your clean — online, by call, or by text.",
  `Text ${PHONE_DISPLAY} and we'll send you our official $Cashtag.`,
  "Send your payment through Cash App after your detail — or pay cash on the spot. Done.",
];

export const CashAppSection = () => (
  <section id="cashapp" className="py-24 sm:py-32">
    <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 lg:grid-cols-2">
      <Reveal>
        <p className="font-mono-alt text-xs font-semibold uppercase tracking-[0.2em] text-[#B45309]">
          03 — Payment
        </p>
        <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-[#111827] sm:text-3xl lg:text-4xl">
          Pay via Cash App — or cash.
        </h2>
        <p className="mt-4 max-w-md text-base leading-relaxed text-[#4B5563]">
          No card readers, no invoices. Quick Cash App payment once your interior is spotless — or just hand us
          cash when we hand back your keys.
        </p>
        <ol className="mt-8 space-y-4">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-start gap-4">
              <span className="font-mono-alt mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#131519] text-xs font-semibold text-white">
                {i + 1}
              </span>
              <span className="text-base leading-relaxed text-[#4B5563]">{s}</span>
            </li>
          ))}
        </ol>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="rounded-3xl bg-[#131519] p-10 text-white sm:p-12" data-testid="cash-app-card">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#00D632]">
            <DollarSign size={28} className="text-white" strokeWidth={2.5} />
          </div>
          <h3 className="font-display mt-8 text-2xl font-bold tracking-tight">Cash App & cash accepted</h3>
          <p className="mt-3 text-sm leading-relaxed text-[#9CA3AF]">
            For your security, we never post our $Cashtag publicly. Text us at{" "}
            <span className="font-semibold text-white">{PHONE_DISPLAY}</span> and we'll reply with our official
            $Cashtag before you send anything.
          </p>
          <a
            data-testid="cash-app-text-button"
            href={`${PHONE_SMS}?&body=Hi Metro Mobile Details! What's your Cash App $Cashtag?`}
            className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#00D632] py-3.5 text-sm font-semibold text-[#131519] transition-colors hover:bg-[#00B029] hover:text-white"
          >
            <MessageSquare size={15} />
            Text for our $Cashtag
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
